import * as http from 'utils/http';
import config from 'config';
import useSWR from 'swr';

import { _getUrlWithFilters } from 'modules/dispatching/service';

const fetcher = (url) => http.get(`${config.API_URL}${url}`);

const useItinerariesForRoutingMap = ({ filters, swrOptions }) => {
  const url = _getUrlWithFilters('routing-map', { ...filters, need_manual_dispatching: true });

  const { data } = useSWR(!!filters ? url : null, fetcher, swrOptions);

  return (data || []).map((itinerary) => ({
    ...itinerary,
    stops: (itinerary.stops || []).map((stop) => ({ ...stop, itinerary_id: itinerary.id })),
  }));
};

const useRoutingMarkers = ({ itineraries, mapStopFilter = [] }) => {
  return (itineraries || [])
    .reduce((acc, itinerary) => [...acc, ...(itinerary?.stops || [])], [])
    .filter((stop) => mapStopFilter.includes(stop?.stop_type));
};

export { useItinerariesForRoutingMap, useRoutingMarkers };
